import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CycleParameter";

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCycleParameters`, options);

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddUpdateCycleParameters`, options);

export default {
  GetAll,
  Create,
};
